<script setup lang="ts">

const error = useError()
const dev = import.meta.dev

onMounted(() => {
  if (error.value) {
    console.error(error.value)
  }
})
</script>
<template>
  <main class="page-wrapper bg-dark mb-5">
    <!-- Page content-->
    <section class="d-flex align-items-center position-relative min-vh-100 py-5">
      <!-- Bg overlay--><span
        class="position-absolute top-50 start-50 translate-middle zindex-1 rounded-circle mt-sm-0 mt-n5"
        style="width: 50vw; height: 50vw; background-color: rgba(83, 74, 117, 0.3); filter: blur(6.4vw);"></span>
      <!-- Overlay content-->
      <div class="container d-flex justify-content-center position-relative zindex-5 text-center">
        <div class="col-lg-8 col-md-10 col-12 px-0">
          <h1 class="display-1 mb-lg-5 mb-4 text-light">Oops!</h1>
          <div class="ratio ratio-16x9 mx-auto mb-lg-5 mb-4 py-4" style="max-width: 556px;">
            <Icon icon="streamline-pixel:internet-network-cloud-error" class="text-primary"/>
          </div>
          <p class="h2 mb-lg-5 mb-4 pb-2 text-light">Ocorreu um erro ao carregar a página</p>
          <nuxt-link class="btn btn-lg btn-primary w-sm-auto w-100 mb-3 me-sm-4" to="/">Voltar para o início</nuxt-link>

          <template v-if="dev">
            <div v-if="error?.statusCode" class="alert alert-danger">
              <h4 class="alert-heading">[{{ error.statusCode }} {{ error.statusMessage }}] {{ error.url }}</h4>
              <p>{{ error.message }}</p>
              <pre class="text-start">{{ error.stack }}</pre>
            </div>
            <pre v-else class="text-start">{{ error }}</pre>
          </template>
        </div>
      </div>
    </section>
  </main>
</template>